export type SkippedDocQueueTab = 'Review' | 'Approved' | 'Archived'

export interface SkippedDocQueueInput {
  reference_number?: string | null
  filename: string
  existing_status?: string
  existing_deleted?: boolean
}

export function skippedDocQueueTab(doc: SkippedDocQueueInput): SkippedDocQueueTab {
  if (doc.existing_deleted) {
    return 'Archived'
  }
  if (doc.existing_status === 'approved') {
    return 'Approved'
  }
  return 'Review'
}

export function skippedDuplicateToastMessage(doc: SkippedDocQueueInput): string {
  const label = doc.reference_number || doc.filename
  const tab = skippedDocQueueTab(doc)
  return `${label} was not added to Review because it already exists in ${tab}.`
}

export function skippedDuplicateToastActionLabel(tab: SkippedDocQueueTab): string {
  return `View in ${tab}`
}
